import React from 'react'
import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'

const cardColors = {
  blue: { background: colors.blue05, text: colors.blue70, scrim: colors.blue90 },
  green: { background: colors.green05, text: colors.green70, scrim: colors.green90 },
  yellow: { background: colors.yellow05, text: colors.yellow70, scrim: colors.yellow90 },
  red: { background: colors.red05, text: colors.red70, scrim: colors.red90 },
  purple: { background: colors.purple05, text: colors.purple70, scrim: colors.purple90 },
}

export default function Notice({ text = 'NOTICE', color = 'blue', position = 'right' }) {
  if (text === null) return null
  const leftOrRight = position === 'left' ? 'left: 12px' : 'right: 12px'

  const noticeCss = css`
    height: 23px;
    width: fit-content;
    top: 12px;
    ${leftOrRight};
    font-size: 12px;
    padding: 6px 15px;
    font-weight: 700;
    border-radius: 4px;
    color: ${cardColors[color].text};
    background-color: ${cardColors[color].background};
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
  `

  return (
    <div css={noticeCss} data-testid="notice">
      {text}
    </div>
  )
}
